import React from 'react';

import CustomOverlayComponent from './customOverlayComponent';

const InfoWindow = (props) => (
	<CustomOverlayComponent
		{...props}
		animationDelay={250}
		className="info-window"
		appendToMap={false}
		gesturesDisabled={false}
	/>
);

export default InfoWindow;
